module.exports = __webpack_public_path__ + "static/media/180716_Griffith_Giulia_121-edit.33d9928f.jpg";